"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoisonedBladesAbilityHandler = exports.PoisonedBladesActorAbilityFactory = exports.PoisonedBladesAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Poisoned_1 = require("../../core/effects/core/Poisoned");
const Registries_1 = require("../../core/state/Registries");
class PoisonedBladesAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.PoisonedBlades;
        this.__typeName = "PoisonedBlades";
    }
}
exports.PoisonedBladesAbilityArgs = PoisonedBladesAbilityArgs;
let PoisonedBladesActorAbilityFactory = class PoisonedBladesActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("PoisonedBlades", "OneEnemies", 1);
    }
};
PoisonedBladesActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("PoisonedBlades")
], PoisonedBladesActorAbilityFactory);
exports.PoisonedBladesActorAbilityFactory = PoisonedBladesActorAbilityFactory;
let PoisonedBladesAbilityHandler = class PoisonedBladesAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Nature", 25),
                AbilityDamage_1.AbilityDamage.Power("Physical", 25),
            ],
            onHit(sequence) {
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Ticks(8),
                    effect: new Poisoned_1.PoisonedEffectArgs("Power", 10),
                    sequence
                });
            }
        });
    }
};
PoisonedBladesAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.PoisonedBlades)
], PoisonedBladesAbilityHandler);
exports.PoisonedBladesAbilityHandler = PoisonedBladesAbilityHandler;
